export interface DevelopmentMenuAccess {
  /** user.accessLevel !== 'leadership-only' && !== 'limited' */
  hasFullAccess: boolean;
  /** isFeatureEnabled('evaluations') */
  evaluationsEnabled: boolean;
  /** isFeatureEnabled('leadership') */
  leadershipEnabled: boolean;
  isTeamMember: boolean;
  isTrainer: boolean;
  isLeader: boolean;
  /** user.accessLevel — 'full' | 'leadership-only' | 'limited' | undefined */
  accessLevel?: string;
}

/**
 * Whether the sidebar "Development" menu group (which contains the Leadership
 * link) should be shown.
 *
 * Trainers who are not leaders are normally excluded — but a trainer who has
 * been *granted* leadership access (accessLevel === 'leadership-only') must be
 * allowed through, otherwise the "Grant access to Leadership pages" toggle has
 * no effect on the navigation.
 */
export function shouldShowDevelopmentMenu(a: DevelopmentMenuAccess): boolean {
  const hasAnyDevelopmentFeature =
    (a.hasFullAccess && a.evaluationsEnabled) || a.leadershipEnabled;

  // A trainer who is not a leader is excluded UNLESS they were granted
  // leadership access via the "Grant access to Leadership pages" toggle.
  const isExcludedTrainer =
    a.isTrainer && !a.isLeader && a.accessLevel !== 'leadership-only';

  return hasAnyDevelopmentFeature && !(a.isTeamMember || isExcludedTrainer);
}
